import { render, staticRenderFns } from "./CreateRename.vue?vue&type=template&id=a5b152b2"
import script from "./CreateRename.vue?vue&type=script&lang=js"
export * from "./CreateRename.vue?vue&type=script&lang=js"
import style0 from "./CreateRename.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports